import { BillSortValue } from "@common/types/bill";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "../useWorkspaceUserCache";

export function useBillsPageSortingCache(): [
    BillSortValue | undefined,
    (value: BillSortValue | undefined) => void,
] {
    const [value, setter] = useWorkspaceUserCache<BillSortValue>(
        WORKSPACE_USER_CACHE_KEYS.BILLS_PAGE_SORTING_CACHE_KEY,
    );

    return [
        value,
        (sorting: BillSortValue | undefined) => {
            setter(sorting);
        },
    ];
}
